import { render, staticRenderFns } from "./Demonstration.vue?vue&type=template&id=086bf31c&scoped=true"
var script = {}
import style0 from "./Demonstration.vue?vue&type=style&index=0&id=086bf31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086bf31c",
  null
  
)

export default component.exports